/*
 * File: Story.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:21 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 28, 2025 at 10:23 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { Card } from '../../../components';

// Constants
import { DetailPanelWidth, mobileBreakpoint, tabBarBreakpoint } from '../../../styles/constants';


/**
 * Styles
 */

export const Wrapper = styled.div`
	display: flex;
	gap: 24px;
	padding: 40px 0px 60px;
	width: 100%;
	justify-content: center;
	align-items: start;

	.detailPanel {
		display: none !important;

		@media only screen and (min-width: ${tabBarBreakpoint}em) {
			display: block !important;
		}
	}
`;

export const StoryCard = styled(Card)`
	padding: 24px 36px 14px;
	max-width: ${DetailPanelWidth}px;
	width: 100%;
	position: relative;
`;

export const NavigationBar = styled.div`
	display: grid;
	grid-gap: 10px;
	grid-template-columns: repeat(1, 1fr);
	padding: 30px 0px 0px;

	& > div {
		width: 100%;
	}
	button {
		width: 100%;

		span {
			font-size: 0.85rem;
		}
	}
	@media only screen and (min-width: ${mobileBreakpoint}em) {
		grid-template-columns: repeat(3, 1fr);
	}
`;
